var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.804,
    height: 17.153,
    viewBox: "0 0 14.804 17.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16296",
    d: "M12.421 2a5.848 5.848 0 0 0-5.848 5.848v4.561l-1.294 1.949A1.591 1.591 0 0 0 6.6 16.814h11.641a1.591 1.591 0 0 0 1.322-2.468l-1.294-1.938v-4.56A5.848 5.848 0 0 0 12.421 2z",
    transform: "translate(-5.023 -2)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16297",
    d: "M20.553 43.559A2.339 2.339 0 0 0 22.755 42H18.35a2.339 2.339 0 0 0 2.203 1.559z",
    transform: "translate(-13.155 -26.406)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.8441ad52e65ca474270d1366575b01fa.svg";
export { ForwardRef as ReactComponent };